import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { AppointmentTypeKind } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { $t } from "@/lib/i18nHelpers";

export const getAppointmentType = (appointment: Appointment) => {
  switch (appointment.typeKind) {
    case AppointmentTypeKind.AUDIO_CALLS:
      return $t("audio call");
    case AppointmentTypeKind.VIDEO_CALLS:
      return $t("video call");
    case AppointmentTypeKind.MESSAGING:
      return $t("messaging");
    case AppointmentTypeKind.TOUR_GUIDE:
      return $t("offline");
  }
};
